<template>
  <div class="document">
    <div class="header">
      <EsHeader>
        <template #header>
          SMTP Properties
        </template>
        <template #actions v-if="hasModule('SYS:SYS:CONFIGMGR:EDIT')">
          <ul>
            <li class="p-narrow no-border">
              <div class="list-content">
                <a role="button"
                  @keypress.enter.prevent="editPanel()"
                  @click="editPanel()"
                  :class="{ disabled: editOtherPanels }"
                  v-if="!editCurrentPanel"
                  :tabindex="editOtherPanels ? -1 : 0"
                >
                  <font-awesome-icon :icon="['far', 'edit']" size="lg" title="Edit" />
                </a>
              </div>
            </li>
          </ul>
        </template>
      </EsHeader>
    </div>
    <div class="content">
      <es-form  style="padding: 1.15rem 0rem">
        <template #es-form>
          <table>
            <tbody>
              <tr>
                <td></td>
                <th
                  class="property has-text-grey table-header-normal"
                  :class="{ 'no-border': editCurrentPanel }"
                >
                  Host Name
                </th>
                <td :class="{ 'no-border': editCurrentPanel }">
                  <div class="control">
                    <input
                      class="input has-text-right is-pulled-right"
                      :class="{
                        'is-static': !editCurrentPanel,
                        'is-danger' : errHostName,
                        }"
                      :readonly="!editCurrentPanel"
                      type="text"
                      v-model="form.EMAIL_HOST"
                      @keyup.prevent="validateField('hostName')"
                      :aria-label="form.EMAIL_HOST || 'Host Name'"
                    >
                    <span v-if="errHostName" class="help is-danger">
                      {{ msgHostName }}
                    </span>
                  </div>
                </td>
              </tr>
              <tr>
                <td></td>
                <th
                  class="property has-text-grey table-header-normal"
                  :class="{ 'no-border': editCurrentPanel }"
                >
                  Port
                </th>
                <td :class="{ 'no-border': editCurrentPanel }">
                  <div class="control">
                    <input
                      class="input has-text-right is-pulled-right"
                      :class="{ 'is-static': !editCurrentPanel ,'is-danger' : errPort }"
                      :readonly="!editCurrentPanel"
                      type="text"
                      v-model="form.SMTP_PORT"
                      @keyup.prevent="validateField('port')"
                      :aria-label="form.SMTP_PORT || 'Port'"
                    >
                    <span v-if="errPort" class="help is-danger">
                      {{ msgPort }}
                    </span>
                  </div>
                </td>
              </tr>
              <tr>
                <td></td>
                <th
                  class="property has-text-grey table-header-normal"
                  :class="{ 'no-border': editCurrentPanel }"
                >
                  TLS Security
                </th>
                <td :class="{ 'no-border': editCurrentPanel }">
                  <div class="control">
                    <div
                      class="buttons has-addons"
                      v-if="editCurrentPanel"
                    >
                      <button
                        class="button button--form"
                        v-for="(option, index) in enabledDisabled"
                        :key="index"
                        @click="form.START_TLS_ENABLED = option.code"
                        :class="{ 'is-active': JSON.parse(form.START_TLS_ENABLED) === option.code }"
                      >
                        {{ option.description }}
                      </button>
                    </div>
                    <input
                      v-else
                      class="input has-text-right is-pulled-right"
                      :class="{ 'is-static': !editCurrentPanel }"
                      type="text"
                      :value="tlsMode"
                      :readonly="!editCurrentPanel"
                      :aria-label="tlsMode"
                    >
                  </div>
                </td>
              </tr>
              <tr>
                <td></td>
                <th
                  class="property has-text-grey table-header-normal"
                  :class="{ 'no-border': editCurrentPanel }"
                >
                  From Address
                </th>
                <td :class="{ 'no-border': editCurrentPanel }">
                  <div class="control">
                    <input
                      class="input has-text-right is-pulled-right"
                      :class="{ 'is-static': !editCurrentPanel ,'is-danger' : errFromAddress }"
                      :readonly="!editCurrentPanel"
                      type="text"
                      v-model="form.FROM_ADDRESS"
                      @keyup.prevent="validateField('fromAddress')"
                      :aria-label="form.FROM_ADDRESS || 'From Address'"
                    >
                    <span v-if="errFromAddress" class="help is-danger">
                      {{ msgFromAddress}}
                    </span>
                  </div>
                </td>
              </tr>
              <tr>
                <td></td>
                <th
                  class="property has-text-grey table-header-normal"
                  :class="{ 'no-border': editCurrentPanel }"
                >
                  SMTP Username
                </th>
                <td :class="{ 'no-border': editCurrentPanel }">
                  <div class="control">
                    <input
                      class="input has-text-right is-pulled-right"
                      :class="{ 'is-static': !editCurrentPanel , 'is-danger' : errSmtpUserName }"
                      :readonly="!editCurrentPanel"
                      type="text"
                      v-model="form.USER_NAME"
                      @keyup.prevent="validateField('userName')"
                      :aria-label="form.USER_NAME || 'SMTP Username'"
                    >
                    <span v-if="errSmtpUserName" class="help is-danger">
                      {{ msgSmtpUserName}}
                    </span>
                  </div>
                </td>
              </tr>
              <tr>
                <td></td>
                <th
                  class="property has-text-grey table-header-normal"
                  :class="{ 'no-border': editCurrentPanel }"
                >
                  SMTP Password
                </th>
                <td :class="{ 'no-border': editCurrentPanel }">
                  <div class="control">
                    <input
                      class="input has-text-right is-pulled-right"
                      :class="{ 'is-static': !editCurrentPanel , 'is-danger' : errSmtpPassword }"
                      :readonly="!editCurrentPanel"
                      type="password"
                      autocomplete="current-password"
                      v-model="form.PASSWORD"
                      @keyup.prevent="validateField('password')"
                      :aria-label="form.PASSWORD || 'SMTP Password'"
                    >
                    <span v-if="errSmtpPassword" class="help is-danger">
                      {{ msgSmtpPassword}}
                    </span>
                  </div>
                </td>
              </tr>
              <tr>
                <td></td>
                <th
                  class="property has-text-grey table-header-normal"
                  :class="{ 'no-border': editCurrentPanel }"
                >
                  Test SMTP
                </th>
                <td :class="{ 'no-border': editCurrentPanel }" style="padding-left: 0">
                  <div>
                    <tr>
                      <th style="width: 80%; padding: 0">
                        <div class="control">
                          <input
                            class="input has-text-right is-pulled-right"
                            :class="{ 'is-danger' : errTestSmtp }"
                            :disabled="editCurrentPanel"
                            type="text"
                            v-model="testEmail"
                            @keyup.prevent="checkForEmail()"
                            :aria-label="testEmail || 'Test SMTP Input'"
                          >
                          <p v-if="errTestSmtp" class="help is-danger">
                            {{ msgTestSmtp }}
                          </p>
                        </div>
                      </th>
                      <td style="width: 101px; padding: 0">
                        <button
                          class="button button-link has-underline is-pulled-right"
                          :class="{ disabled: editCurrentPanel }"
                          @click.prevent='sendTestEmail()'
                        >
                          Send Test Email
                        </button>
                      </td>
                    </tr>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </template>
      </es-form>
    </div>
    <div
      v-if="editCurrentPanel"
      class="is-flex flex-justify--end flex-align--center"
      style="margin-right: 5.15rem; padding-bottom: 2rem"
    >
      <button
        class="button button-link has-underline"
        @click.prevent="cancelPanel()"
        style="margin-right: 1rem"
      >
        Cancel
      </button>
      <button
        class="button is-primary"
        @click.prevent="updatePanel()"
      >
        Update
      </button>
    </div>
  </div>
</template>

<script>
import axios from 'axios';
import { mapGetters, mapActions } from 'vuex';
import EsForm from '@/components/EsForm.vue';
import EsHeader from '@/components/EsHeader.vue';
import NotificationManager from '@/mixins/NotificationManager';
import PermissionManager from '@/mixins/PermissionManager';
import EmailUtils from '@/mixins/EmailUtils';

export default {
  mixins: [
    NotificationManager,
    PermissionManager,
    EmailUtils,
  ],
  components: {
    EsForm,
    EsHeader,
  },
  props: {
    editOtherPanels: {
      type: Boolean,
    },
  },
  data() {
    return this.initialData();
  },
  created() {
    this.initialize(this.properties);
    this.enabledDisabled = [
      {
        code: true,
        description: 'Enabled',
      },
      {
        code: false,
        description: 'Disabled',
      },
    ];
  },
  mounted() {
    this.updateCache();
  },
  computed: {
    ...mapGetters('propertiesModule', [
      'properties',
    ]),
    tlsMode() {
      return JSON.parse(this.form.START_TLS_ENABLED.toString().toLowerCase()) === true
        ? 'Enabled' : 'Disabled';
    },
  },
  methods: {
    ...mapActions({
      initProperties: 'propertiesModule/init',
    }),
    cancelPanel() {
      this.undoForm();
      this.resetFormErrors();
      this.resetNotifications();
      this.editCurrentPanel = false;
      this.$emit('allowEditOtherPanels');
    },
    checkForEmail() {
      if (this.testEmail) {
        this.validEmailFormat(this.testEmail);
      } else {
        this.errTestSmtp = false;
        this.msgTestSmtp = null;
      }
    },
    checkForFormChanges() {
      return this.compareObjects(this.cache, this.form);
    },
    compareObjects(o, n) {
      return JSON.stringify(o) !== JSON.stringify(n);
    },
    editPanel() {
      this.editCurrentPanel = !this.editCurrentPanel;
      this.$emit('allowEditOtherPanels');
    },
    groupBySection(data, type) {
      return Object.entries(data)
        .filter(([key]) => key.includes(type))
        .map(([key, val]) => ({ [key.replace(type, '')]: val }));
    },
    initialData() {
      return {
        editCurrentPanel: false,
        cache: {},
        form: {},
        testEmail: null,
        errHostName: false,
        errPort: false,
        errFromAddress: false,
        errSmtpUserName: false,
        errSmtpPassword: false,
        errTestSmtp: false,
        msgHostName: null,
        msgPort: null,
        msgFromAddress: null,
        msgSmtpUserName: null,
        msgSmtpPassword: null,
        msgTestSmtp: null,
      };
    },
    initialize(data) {
      this.form = Object.assign({}, ...this.groupBySection(data, 'SMTP-'));
    },
    prepForRequest() {
      let payload = [];
      let cached = null;
      let obj = null;
      obj = this.form;
      cached = this.cache;
      this.pushToPayLoad('SMTP', payload, obj, cached);
      payload = payload.filter(p => p.property !== 'TEST_EMAIL');
      return payload;
    },
    pushToPayLoad(category, payload, obj, cached) {
      Object.entries(obj).forEach(([property, value]) => {
        if (value !== cached[property]) {
          payload.push({ category, property, value });
        }
      });
    },
    async sendTestEmail() {
      if (!this.testEmail || this.testEmail === '') {
        this.errTestSmtp = true;
        this.msgTestSmtp = 'Test email is required.';
        this.showNotification('danger', ['There were some errors. Please fix the errors highlighted in the fields below.']);
      } else {
        try {
          await axios.post(`/properties/send-testemail?emailAddress=${this.testEmail}`, {});
          this.showNotification('success', ['Test Email has been sent successfully.']);
        } catch (error) {
          this.showNotification('danger', ['Test Email could not be sent successfully.']);
        }
      }
    },
    undoForm() {
      this.form = JSON.parse(JSON.stringify(this.cache));
    },
    updateCache() {
      this.cache = JSON.parse(JSON.stringify(this.form));
    },
    async updatePanel() {
      const changes = this.checkForFormChanges();
      if (!changes) {
        this.editCurrentPanel = false;
        this.resetNotifications();
        return;
      }
      if (this.checkFieldValidations()) return;
      try {
        await axios({
          method: 'put',
          url: '/properties',
          data: this.prepForRequest(),
        });
        this.updateCache();
        await this.initProperties();
        this.showNotification('success', ['The SMTP Properties have been updated successfully.']);
        this.$emit('allowEditOtherPanels');
        this.editCurrentPanel = false;
      } catch (error) {
        if (error.response.status === 400) {
          this.$emit('allowEditOtherPanels');
          this.apiMsg = 'There was an issue. Please try again or contact your administrator.';
        } else {
          this.apiMsg = 'There were some errors. Please fix the errors highlighted in the fields below.';
        }
        this.showNotification('danger', [this.apiMsg]);
      }
    },
    validEmailFormat(userEmail) {
      this.errTestSmtp = false;
      this.msgTestSmtp = null;
      if (!this.isWelformed(userEmail)) {
        this.errTestSmtp = true;
        this.msgTestSmtp = 'Invalid Email !!!';
      }
    },
    checkFieldValidations() {
      this.validateField('hostName');
      this.validateField('port');
      this.validateField('userName');
      this.validateField('password');
      this.checkForEmail();
      const err = this.errHostName
        || this.errPort
        || this.errSmtpUserName
        || this.errSmtpPassword
        || this.errTestSmtp;
      if (err) {
        this.showNotification('danger', ['There were some errors. Please fix the errors highlighted in the fields below.']);
      } else {
        this.resetNotifications();
      }
      return err;
    },
    resetFormErrors() {
      this.errHostName = false;
      this.errPort = false;
      this.errFromAddress = false;
      this.errSmtpUserName = false;
      this.errSmtpPassword = false;
      this.errTestSmtp = false;
      this.msgHostName = null;
      this.msgPort = null;
      this.msgFromAddress = null;
      this.msgSmtpUserName = null;
      this.msgSmtpPassword = null;
      this.msgTestSmtp = null;
    },
    validateField(userInput) {
      if (userInput === 'hostName') {
        if (!this.form.EMAIL_HOST) {
          this.errHostName = true;
          this.msgHostName = 'Host Name is required';
        } else {
          this.errHostName = false;
          this.msgHostName = null;
        }
      }
      if (userInput === 'port') {
        if (!this.form.SMTP_PORT) {
          this.errPort = true;
          this.msgPort = 'Port is required';
        } else {
          this.errPort = false;
          this.msgPort = null;
        }
      }
      if (userInput === 'fromAddress') {
        if (!this.form.FROM_ADDRESS) {
          this.errFromAddress = true;
          this.msgFromAddress = 'From Address is required';
        } else if (this.form.FROM_ADDRESS
           && !this.isWelformed(this.form.FROM_ADDRESS)) {
          this.errFromAddress = true;
          this.msgFromAddress = 'From Address is invalid';
        } else {
          this.errFromAddress = false;
          this.msgFromAddress = null;
        }
      }
      if (userInput === 'userName') {
        if (!this.form.USER_NAME && this.form.START_TLS_ENABLED) {
          this.errSmtpUserName = true;
          this.msgSmtpUserName = 'SMTP Username is required';
        } else if (!this.form.USER_NAME
            && !this.form.START_TLS_ENABLED && this.form.PASSWORD) {
          this.errSmtpUserName = true;
          this.msgSmtpUserName = 'SMTP Username is required';
        } else {
          this.errSmtpUserName = false;
          this.msgSmtpUserName = null;
        }
      }
      if (userInput === 'password') {
        if (!this.form.PASSWORD && this.form.START_TLS_ENABLED) {
          this.errSmtpPassword = true;
          this.msgSmtpPassword = 'SMTP Password is required';
        } else if (!this.form.USER_NAME
            && !this.form.START_TLS_ENABLED && !this.form.PASSWORD) {
          this.errSmtpUserName = false;
          this.msgSmtpUserName = null;
        } else {
          this.errSmtpPassword = false;
          this.msgSmtpPassword = null;
        }
      }
    },
    resetNotifications() {
      this.hideNotification();
      this.$store.state.notifications.isActive = false;
      this.$store.state.notifications.notificationType = null;
    },
  },
};
</script>

<style lang="sass" scoped>
  table td
    vertical-align: middle
    &:first-child
      border: 0
      width: 30px
  table th
    vertical-align: middle
  a.disabled
    color: #999
    cursor: default
    text-decoration: none
    pointer-events: none
    &:hover
      text-decoration: none
  button.disabled
    color: #999
    cursor: default
    text-decoration: none
    pointer-events: none
    &:hover
      text-decoration: none
  .property
    padding-left: 0
    font-size: 12px
    width: 25%
  .no-border
    border: 0
  .buttons
    float: right
  .tls-empty
    border-color: #ff3860 !important
</style>
